

export const authSelector = (state) => state.auth;
export const userSelector = (state) => state.user;